import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_13 = { class: "small-fs-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_18 = { class: "setting-data" }
const _hoisted_19 = { class: "row align-items-center" }
const _hoisted_20 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_21 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "table" }
const _hoisted_24 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_25 = { class: "d-block my-3" }
const _hoisted_26 = { class: "d-none d-md-block" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "5" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_37 = { style: {"padding":"5px 0"} }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { style: {"padding":"5px 0"} }
const _hoisted_41 = { class: "bold" }
const _hoisted_42 = { style: {"padding":"5px 0"} }
const _hoisted_43 = { class: "bold" }
const _hoisted_44 = {
  key: 0,
  class: "bi bi-cash-stack"
}
const _hoisted_45 = {
  key: 1,
  class: "bi bi-phone-vibrate-fill"
}
const _hoisted_46 = {
  key: 2,
  class: "bi bi-wallet-fill"
}
const _hoisted_47 = { style: {"padding":"5px 0"} }
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_51 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_57 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_58 = { class: "d-none t-d-md-table-cell" }
const _hoisted_59 = {
  key: 0,
  class: "bi bi-cash-stack"
}
const _hoisted_60 = {
  key: 1,
  class: "bi bi-phone-vibrate-fill"
}
const _hoisted_61 = {
  key: 2,
  class: "bi bi-wallet-fill"
}
const _hoisted_62 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_63 = { class: "d-none t-d-md-table-cell" }
const _hoisted_64 = { class: "sett-small-menu align-right" }
const _hoisted_65 = { class: "discl-menu dropdown" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_67 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-fill" }, null, -1)
const _hoisted_73 = { class: "col-md-6 col-sm-12" }
const _hoisted_74 = { class: "area-info" }
const _hoisted_75 = { class: "col-md-6 col-sm-12" }
const _hoisted_76 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_PurchasePaytModal = _resolveComponent("PurchasePaytModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.payments), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              (!_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_RouterLink, { to: "/app/products/purchases/list" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("  " + _toDisplayString(_ctx.language.po) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.relatedPurchase.record.PurchaseOrderNbr), 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.language.supplier) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getSupplierName), 1)
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("p", _hoisted_13, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.language.total_amt) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.purchaseInfoSit.OrderValue)) + " ", 1),
              _hoisted_14,
              _createElementVNode("strong", null, _toDisplayString(_ctx.language.amt_paid) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.purchaseInfoSit.AmtPaid)) + " ", 1),
              _hoisted_15,
              _createElementVNode("strong", null, _toDisplayString(_ctx.language.remaining) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.purchaseInfoSit.RemAmt)) + " ", 1),
              _hoisted_16
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_payments_msg), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.language.payments), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddEditPaytOper(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstPaymentsForPurchaseOrder.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_22),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_23, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.language.payments), 1)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.language.doct_nbr), 1)
                  ]),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.payt_date), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.type), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.payt_amt), 1),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstPaymentsForPurchaseOrder.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (recProduct) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recProduct.IdPurchasePayment
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddEditPaytOper(1, recProduct))
                        }, _toDisplayString(recProduct.PaytDoctNbr), 9, _hoisted_35)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.language.doct_nbr) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddEditPaytOper(1, recProduct))
                          }, _toDisplayString(recProduct.PaytDoctNbr), 9, _hoisted_39)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.language.payt_date) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(_ctx.appFxs.formatDate(recProduct.PaytDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.language.type) + ": ", 1),
                          _createTextVNode("  "),
                          (recProduct.PaytType == 0)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                            : _createCommentVNode("", true),
                          (recProduct.PaytType == 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                            : _createCommentVNode("", true),
                          (recProduct.PaytType == 2)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                            : _createCommentVNode("", true),
                          _createTextVNode("   " + _toDisplayString(_ctx.appFxs.getPaytTypes()[recProduct.PaytType].label), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.language.payt_amt) + ": ", 1),
                          _createTextVNode("  " + _toDisplayString(_ctx.currCode + ' ' + _ctx.appFxs.formatNumbers(recProduct.PaytAmt)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddEditPaytOper(1, recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_52),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteRecordAction(recProduct))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_53),
                            _hoisted_54,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.printDocumentRecord(recProduct))
                            }, [
                              _hoisted_56,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                            ], 8, _hoisted_55)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.appFxs.formatDate(recProduct.PaytDate)), 1),
                    _createElementVNode("td", _hoisted_58, [
                      (recProduct.PaytType == 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_59))
                        : _createCommentVNode("", true),
                      (recProduct.PaytType == 1)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                        : _createCommentVNode("", true),
                      (recProduct.PaytType == 2)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                        : _createCommentVNode("", true),
                      _createTextVNode("   " + _toDisplayString(_ctx.appFxs.getPaytTypes()[recProduct.PaytType].label), 1)
                    ]),
                    _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.PaytAmt)), 1),
                    _createElementVNode("td", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("ul", _hoisted_67, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.showAddEditPaytOper(1, recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_68)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deleteRecordAction(recProduct))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_69)
                            ]),
                            _hoisted_70,
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.printDocumentRecord(recProduct))
                              }, [
                                _hoisted_72,
                                _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                              ], 8, _hoisted_71)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstPaymentsForPurchaseOrder.length==0}])
            }, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstPaymentsForPurchaseOrder.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("nav", _hoisted_76, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredDataItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_PurchasePaytModal, {
        visible: _ctx.isPaytDlgVisible,
        initialValues: _ctx.paytInitialValues,
        recordStatus: _ctx.detailRecordStatus,
        remainAmt: _ctx.purchaseInfoSit.RemAmt,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "remainAmt", "onCloseForm"])
    ]))
  ], 64))
}